<template>
  <div id="app">
    <router-view/>
  </div>
</template>


<script>
export default {
  name: 'App',
  methods:{
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },
  mounted(){
    if (this._isMobile()) {
      // 跳转至手机端路由
      // alert("手机端");
      this.$router.replace("/");
    } else {
      // 跳转至 pc 端路由
      // alert("pc端");
      this.$router.replace("/pc-home");
    }
  }
}
</script>



<style lang="less">
#app {
  font-family: 'Microsoft Yahei', sans-serif, -apple-system, Helvetica, Arial;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
